import { render, staticRenderFns } from "./ManufacturerPostDialog.vue?vue&type=template&id=ab766fd6&scoped=true&"
import script from "./ManufacturerPostDialog.vue?vue&type=script&lang=js&"
export * from "./ManufacturerPostDialog.vue?vue&type=script&lang=js&"
import style0 from "./ManufacturerPostDialog.vue?vue&type=style&index=0&id=ab766fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab766fd6",
  null
  
)

export default component.exports